const serviceNames = {
    driverService : 'driver_service',
    deviceService: 'device_service',
    tokenService: 'token_service',
    userService: 'user_service'
};

export const getServiceName = (service) => {
    return serviceNames.hasOwnProperty(service)? serviceNames[service]: undefined;
};
